import { render, staticRenderFns } from "./VlNotification.vue?vue&type=template&id=38a75b3a&"
import script from "./VlNotification.vue?vue&type=script&lang=js&"
export * from "./VlNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports